"use client";
import { j as M } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as be } from "./tv.config-BuYIgndg.mjs";
import { C as Te } from "./check-BIIp9_Zd.mjs";
import * as g from "react";
import G from "react";
import { u as ee } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as Me } from "./useLatestRef-BZ_hd_SE.mjs";
import { u as Ne, I as Ae } from "./useCompositeListItem-Dxy1vBYe.mjs";
import { u as X } from "./useRenderElement-B8V3_e8R.mjs";
import { u as Ve } from "./useButton-CQeWQM5o.mjs";
import { u as De, a as Le } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { t as ke } from "./useAnimationsFinished-DDpUuXkZ.mjs";
var je = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let u = !1;
    try {
      const o = {};
      e(o) === o && (u = !0);
    } catch {
    }
    if (u) {
      let o;
      try {
        throw new Error();
      } catch (r) {
        ({ stack: o } = r);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, ze = (e, t, n) => {
  const { memoize: u, memoizeOptions: o } = t, { inputSelectorResults: r, inputSelectorResultsCopy: p } = e, s = u(() => ({}), ...o);
  if (!(s.apply(null, r) === s.apply(null, p))) {
    let c;
    try {
      throw new Error();
    } catch (l) {
      ({ stack: c } = l);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: r,
        secondInputs: p,
        stack: c
      }
    );
  }
}, Be = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, W = /* @__PURE__ */ Symbol("NOT_FOUND");
function Ue(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Fe(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function We(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (u) => typeof u == "function" ? `function ${u.name || "unnamed"}()` : typeof u
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var te = (e) => Array.isArray(e) ? e : [e];
function Ge(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return We(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function ne(e, t) {
  const n = [], { length: u } = e;
  for (let o = 0; o < u; o++)
    n.push(e[o].apply(null, t));
  return n;
}
var Ke = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: u } = {
    ...Be,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: je
    },
    inputStabilityCheck: {
      shouldRun: u === "always" || u === "once" && e,
      run: ze
    }
  };
};
function qe(e) {
  let t;
  return {
    get(n) {
      return t && e(t.key, n) ? t.value : W;
    },
    put(n, u) {
      t = { key: n, value: u };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function He(e, t) {
  let n = [];
  function u(s) {
    const v = n.findIndex((c) => t(s, c.key));
    if (v > -1) {
      const c = n[v];
      return v > 0 && (n.splice(v, 1), n.unshift(c)), c.value;
    }
    return W;
  }
  function o(s, v) {
    u(s) === W && (n.unshift({ key: s, value: v }), n.length > e && n.pop());
  }
  function r() {
    return n;
  }
  function p() {
    n = [];
  }
  return { get: u, put: o, getEntries: r, clear: p };
}
var Pe = (e, t) => e === t;
function $e(e) {
  return function(n, u) {
    if (n === null || u === null || n.length !== u.length)
      return !1;
    const { length: o } = n;
    for (let r = 0; r < o; r++)
      if (!e(n[r], u[r]))
        return !1;
    return !0;
  };
}
function Ye(e, t) {
  const n = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: u = Pe,
    maxSize: o = 1,
    resultEqualityCheck: r
  } = n, p = $e(u);
  let s = 0;
  const v = o <= 1 ? qe(p) : He(o, p);
  function c() {
    let l = v.get(arguments);
    if (l === W) {
      if (l = e.apply(null, arguments), s++, r) {
        const i = v.getEntries().find(
          (d) => r(d.value, l)
        );
        i && (l = i.value, s !== 0 && s--);
      }
      v.put(arguments, l);
    }
    return l;
  }
  return c.clearCache = () => {
    v.clear(), c.resetResultsCount();
  }, c.resultsCount = () => s, c.resetResultsCount = () => {
    s = 0;
  }, c;
}
var Xe = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Je = typeof WeakRef < "u" ? WeakRef : Xe, Qe = 0, re = 1;
function j() {
  return {
    s: Qe,
    v: void 0,
    o: null,
    p: null
  };
}
function ae(e, t = {}) {
  let n = j();
  const { resultEqualityCheck: u } = t;
  let o, r = 0;
  function p() {
    var a;
    let s = n;
    const { length: v } = arguments;
    for (let i = 0, d = v; i < d; i++) {
      const m = arguments[i];
      if (typeof m == "function" || typeof m == "object" && m !== null) {
        let f = s.o;
        f === null && (s.o = f = /* @__PURE__ */ new WeakMap());
        const h = f.get(m);
        h === void 0 ? (s = j(), f.set(m, s)) : s = h;
      } else {
        let f = s.p;
        f === null && (s.p = f = /* @__PURE__ */ new Map());
        const h = f.get(m);
        h === void 0 ? (s = j(), f.set(m, s)) : s = h;
      }
    }
    const c = s;
    let l;
    if (s.s === re)
      l = s.v;
    else if (l = e.apply(null, arguments), r++, u) {
      const i = ((a = o == null ? void 0 : o.deref) == null ? void 0 : a.call(o)) ?? o;
      i != null && u(i, l) && (l = i, r !== 0 && r--), o = typeof l == "object" && l !== null || typeof l == "function" ? new Je(l) : l;
    }
    return c.s = re, c.v = l, l;
  }
  return p.clearCache = () => {
    n = j(), p.resetResultsCount();
  }, p.resultsCount = () => r, p.resetResultsCount = () => {
    r = 0;
  }, p;
}
function de(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, u = (...o) => {
    let r = 0, p = 0, s, v = {}, c = o.pop();
    typeof c == "object" && (v = c, c = o.pop()), Ue(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const l = {
      ...n,
      ...v
    }, {
      memoize: a,
      memoizeOptions: i = [],
      argsMemoize: d = ae,
      argsMemoizeOptions: m = [],
      devModeChecks: f = {}
    } = l, h = te(i), I = te(m), R = Ge(o), x = a(function() {
      return r++, c.apply(
        null,
        arguments
      );
    }, ...h);
    let w = !0;
    const C = d(function() {
      p++;
      const y = ne(
        R,
        arguments
      );
      if (s = x.apply(null, y), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: O, inputStabilityCheck: b } = Ke(w, f);
        if (O.shouldRun && O.run(
          c,
          y,
          s
        ), b.shouldRun) {
          const N = ne(
            R,
            arguments
          );
          b.run(
            { inputSelectorResults: y, inputSelectorResultsCopy: N },
            { memoize: a, memoizeOptions: h },
            arguments
          );
        }
        w && (w = !1);
      }
      return s;
    }, ...I);
    return Object.assign(C, {
      resultFunc: c,
      memoizedResultFunc: x,
      dependencies: R,
      dependencyRecomputations: () => p,
      resetDependencyRecomputations: () => {
        p = 0;
      },
      lastResult: () => s,
      recomputations: () => r,
      resetRecomputations: () => {
        r = 0;
      },
      memoize: a,
      argsMemoize: d
    });
  };
  return Object.assign(u, {
    withTypes: () => u
  }), u;
}
var Ze = /* @__PURE__ */ de(ae), et = Object.assign(
  (e, t = Ze) => {
    Fe(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), u = n.map(
      (r) => e[r]
    );
    return t(
      u,
      (...r) => r.reduce((p, s, v) => (p[n[v]] = s, p), {})
    );
  },
  { withTypes: () => et }
);
de({
  memoize: Ye,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
});
const E = (e, t, n, u, o, r, ...p) => {
  if (p.length > 0)
    throw new Error("Unsupported number of selectors");
  let s;
  if (e)
    s = e;
  else
    throw new Error("Missing arguments");
  return s;
};
var z = { exports: {} }, H = {}, B = { exports: {} }, P = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oe;
function tt() {
  if (oe) return P;
  oe = 1;
  var e = G;
  function t(a, i) {
    return a === i && (a !== 0 || 1 / a === 1 / i) || a !== a && i !== i;
  }
  var n = typeof Object.is == "function" ? Object.is : t, u = e.useState, o = e.useEffect, r = e.useLayoutEffect, p = e.useDebugValue;
  function s(a, i) {
    var d = i(), m = u({ inst: { value: d, getSnapshot: i } }), f = m[0].inst, h = m[1];
    return r(
      function() {
        f.value = d, f.getSnapshot = i, v(f) && h({ inst: f });
      },
      [a, d, i]
    ), o(
      function() {
        return v(f) && h({ inst: f }), a(function() {
          v(f) && h({ inst: f });
        });
      },
      [a]
    ), p(d), d;
  }
  function v(a) {
    var i = a.getSnapshot;
    a = a.value;
    try {
      var d = i();
      return !n(a, d);
    } catch {
      return !0;
    }
  }
  function c(a, i) {
    return i();
  }
  var l = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return P.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : l, P;
}
var $ = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var se;
function nt() {
  return se || (se = 1, process.env.NODE_ENV !== "production" && function() {
    function e(d, m) {
      return d === m && (d !== 0 || 1 / d === 1 / m) || d !== d && m !== m;
    }
    function t(d, m) {
      l || o.startTransition === void 0 || (l = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var f = m();
      if (!a) {
        var h = m();
        r(f, h) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), a = !0);
      }
      h = p({
        inst: { value: f, getSnapshot: m }
      });
      var I = h[0].inst, R = h[1];
      return v(
        function() {
          I.value = f, I.getSnapshot = m, n(I) && R({ inst: I });
        },
        [d, f, m]
      ), s(
        function() {
          return n(I) && R({ inst: I }), d(function() {
            n(I) && R({ inst: I });
          });
        },
        [d]
      ), c(f), f;
    }
    function n(d) {
      var m = d.getSnapshot;
      d = d.value;
      try {
        var f = m();
        return !r(d, f);
      } catch {
        return !0;
      }
    }
    function u(d, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = G, r = typeof Object.is == "function" ? Object.is : e, p = o.useState, s = o.useEffect, v = o.useLayoutEffect, c = o.useDebugValue, l = !1, a = !1, i = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : t;
    $.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : i, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), $;
}
var ue;
function fe() {
  return ue || (ue = 1, process.env.NODE_ENV === "production" ? B.exports = tt() : B.exports = nt()), B.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ie;
function rt() {
  if (ie) return H;
  ie = 1;
  var e = G, t = fe();
  function n(c, l) {
    return c === l && (c !== 0 || 1 / c === 1 / l) || c !== c && l !== l;
  }
  var u = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, r = e.useRef, p = e.useEffect, s = e.useMemo, v = e.useDebugValue;
  return H.useSyncExternalStoreWithSelector = function(c, l, a, i, d) {
    var m = r(null);
    if (m.current === null) {
      var f = { hasValue: !1, value: null };
      m.current = f;
    } else f = m.current;
    m = s(
      function() {
        function I(S) {
          if (!R) {
            if (R = !0, x = S, S = i(S), d !== void 0 && f.hasValue) {
              var y = f.value;
              if (d(y, S))
                return w = y;
            }
            return w = S;
          }
          if (y = w, u(x, S)) return y;
          var O = i(S);
          return d !== void 0 && d(y, O) ? (x = S, y) : (x = S, w = O);
        }
        var R = !1, x, w, C = a === void 0 ? null : a;
        return [
          function() {
            return I(l());
          },
          C === null ? void 0 : function() {
            return I(C());
          }
        ];
      },
      [l, a, i, d]
    );
    var h = o(c, m[0], m[1]);
    return p(
      function() {
        f.hasValue = !0, f.value = h;
      },
      [h]
    ), v(h), h;
  }, H;
}
var Y = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ce;
function ot() {
  return ce || (ce = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, l) {
      return c === l && (c !== 0 || 1 / c === 1 / l) || c !== c && l !== l;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = G, n = fe(), u = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, r = t.useRef, p = t.useEffect, s = t.useMemo, v = t.useDebugValue;
    Y.useSyncExternalStoreWithSelector = function(c, l, a, i, d) {
      var m = r(null);
      if (m.current === null) {
        var f = { hasValue: !1, value: null };
        m.current = f;
      } else f = m.current;
      m = s(
        function() {
          function I(S) {
            if (!R) {
              if (R = !0, x = S, S = i(S), d !== void 0 && f.hasValue) {
                var y = f.value;
                if (d(y, S))
                  return w = y;
              }
              return w = S;
            }
            if (y = w, u(x, S))
              return y;
            var O = i(S);
            return d !== void 0 && d(y, O) ? (x = S, y) : (x = S, w = O);
          }
          var R = !1, x, w, C = a === void 0 ? null : a;
          return [
            function() {
              return I(l());
            },
            C === null ? void 0 : function() {
              return I(C());
            }
          ];
        },
        [l, a, i, d]
      );
      var h = o(c, m[0], m[1]);
      return p(
        function() {
          f.hasValue = !0, f.value = h;
        },
        [h]
      ), v(h), h;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Y;
}
var le;
function st() {
  return le || (le = 1, process.env.NODE_ENV === "production" ? z.exports = rt() : z.exports = ot()), z.exports;
}
var ut = st();
function U(e, t, n, u, o) {
  const r = (p) => t(p, n, u, o);
  return ut.useSyncExternalStoreWithSelector(e.subscribe, e.getSnapshot, e.getSnapshot, r);
}
const F = {
  id: E((e) => e.id),
  modal: E((e) => e.modal),
  multiple: E((e) => e.multiple),
  items: E((e) => e.items),
  value: E((e) => e.value),
  label: E((e) => e.label),
  open: E((e) => e.open),
  mounted: E((e) => e.mounted),
  forceMount: E((e) => e.forceMount),
  transitionStatus: E((e) => e.transitionStatus),
  touchModality: E((e) => e.touchModality),
  activeIndex: E((e) => e.activeIndex),
  selectedIndex: E((e) => e.selectedIndex),
  isActive: E((e, t) => e.activeIndex === t),
  isSelected: E((e, t, n) => e.multiple ? Array.isArray(e.value) && e.value.includes(n) : e.selectedIndex === t || e.value === n),
  isSelectedByFocus: E((e, t) => e.selectedIndex === t),
  popupProps: E((e) => e.popupProps),
  triggerProps: E((e) => e.triggerProps),
  triggerElement: E((e) => e.triggerElement),
  positionerElement: E((e) => e.positionerElement),
  scrollUpArrowVisible: E((e) => e.scrollUpArrowVisible),
  scrollDownArrowVisible: E((e) => e.scrollDownArrowVisible)
}, pe = /* @__PURE__ */ g.createContext(null);
process.env.NODE_ENV !== "production" && (pe.displayName = "SelectRootContext");
const me = /* @__PURE__ */ g.createContext(null);
process.env.NODE_ENV !== "production" && (me.displayName = "SelectFloatingContext");
function he() {
  const e = g.useContext(pe);
  if (e === null)
    throw new Error("Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>.");
  return e;
}
function xt() {
  const e = g.useContext(me);
  if (e === null)
    throw new Error("Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>.");
  return e;
}
function it(e) {
  const t = e.currentTarget.getBoundingClientRect();
  return t.top + 1 <= e.clientY && e.clientY <= t.bottom - 1 && t.left + 1 <= e.clientX && e.clientX <= t.right - 1;
}
const J = /* @__PURE__ */ g.createContext(void 0);
process.env.NODE_ENV !== "production" && (J.displayName = "SelectItemContext");
function Q() {
  const e = g.useContext(J);
  if (!e)
    throw new Error("Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>.");
  return e;
}
const ve = /* @__PURE__ */ g.memo(/* @__PURE__ */ g.forwardRef(function(t, n) {
  const {
    render: u,
    className: o,
    value: r = null,
    label: p,
    disabled: s = !1,
    nativeButton: v = !1,
    ...c
  } = t, l = g.useRef(null), a = Ne({
    label: p,
    textRef: l,
    indexGuessBehavior: Ae.GuessFromOrder
  }), {
    store: i,
    getItemProps: d,
    setOpen: m,
    setValue: f,
    selectionRef: h,
    typingRef: I,
    valuesRef: R,
    registerItemIndex: x,
    keyboardActiveRef: w,
    highlightTimeout: C,
    multiple: S
  } = he(), y = U(i, F.isActive, a.index), O = U(i, F.isSelected, a.index, r), b = U(i, F.value), N = U(i, F.isSelectedByFocus, a.index), Ee = g.useRef(null), T = Me(a.index), A = a.index !== -1;
  ee(() => {
    if (!A)
      return;
    const _ = R.current;
    return _[a.index] = r, () => {
      delete _[a.index];
    };
  }, [A, a.index, r, R]), ee(() => {
    A && (S ? Array.isArray(b) && b.includes(r) && x(a.index) : r === b && x(a.index));
  }, [A, a.index, x, r, b, S]);
  const _e = g.useMemo(() => ({
    disabled: s,
    selected: O,
    highlighted: y
  }), [s, O, y]), K = d({
    active: y,
    selected: O
  });
  delete K.onFocus, delete K.id;
  const V = g.useRef(null), D = g.useRef("mouse"), L = g.useRef(!1), {
    getButtonProps: Ie,
    buttonRef: Oe
  } = Ve({
    disabled: s,
    focusableWhenDisabled: !0,
    native: v
  });
  function Z(_) {
    if (S) {
      const k = Array.isArray(b) ? b : [], q = O ? k.filter((Ce) => Ce !== r) : [...k, r];
      f(q, _);
    } else
      f(r, _), m(!1, _, "item-press");
  }
  const Re = {
    "aria-disabled": s || void 0,
    tabIndex: y ? 0 : -1,
    onFocus() {
      i.set("activeIndex", T.current);
    },
    onMouseEnter() {
      !w.current && i.state.selectedIndex === null && i.set("activeIndex", T.current);
    },
    onMouseMove() {
      i.set("activeIndex", T.current);
    },
    onMouseLeave(_) {
      w.current || it(_) || C.start(0, () => {
        i.state.activeIndex === T.current && i.set("activeIndex", null);
      });
    },
    onTouchStart() {
      h.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1,
        allowSelect: !0
      };
    },
    onKeyDown(_) {
      h.current.allowSelect = !0, V.current = _.key, i.set("activeIndex", T.current);
    },
    onClick(_) {
      L.current = !1, !(_.type === "keydown" && V.current === null) && (s || V.current === " " && I.current || D.current !== "touch" && !y || h.current.allowSelect && (V.current = null, Z(_.nativeEvent)));
    },
    onPointerEnter(_) {
      D.current = _.pointerType;
    },
    onPointerDown(_) {
      D.current = _.pointerType, L.current = !0;
    },
    onMouseUp(_) {
      if (s)
        return;
      if (L.current) {
        L.current = !1;
        return;
      }
      const k = !h.current.allowSelectedMouseUp && O, q = !h.current.allowUnselectedMouseUp && !O;
      k || q || D.current !== "touch" && !y || ((h.current.allowSelect || !O) && Z(_.nativeEvent), h.current.allowSelect = !0);
    }
  }, xe = X("div", t, {
    ref: [Oe, n, a.ref, Ee],
    state: _e,
    props: [K, Re, c, Ie]
  }), we = g.useMemo(() => ({
    selected: O,
    indexRef: T,
    textRef: l,
    selectedByFocus: N
  }), [O, T, l, N]);
  return /* @__PURE__ */ M.jsx(J.Provider, {
    value: we,
    children: xe
  });
}));
process.env.NODE_ENV !== "production" && (ve.displayName = "SelectItem");
const Se = /* @__PURE__ */ g.forwardRef(function(t, n) {
  const u = t.keepMounted ?? !1, {
    selected: o
  } = Q();
  return u || o ? /* @__PURE__ */ M.jsx(ye, {
    ...t,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (Se.displayName = "SelectItemIndicator");
const ye = /* @__PURE__ */ g.memo(/* @__PURE__ */ g.forwardRef((e, t) => {
  const {
    render: n,
    className: u,
    keepMounted: o,
    ...r
  } = e, {
    selected: p
  } = Q(), s = g.useRef(null), {
    mounted: v,
    transitionStatus: c,
    setMounted: l
  } = De(p), a = g.useMemo(() => ({
    selected: p,
    transitionStatus: c
  }), [p, c]), i = X("span", e, {
    ref: [t, s],
    state: a,
    props: [{
      hidden: !v,
      "aria-hidden": !0,
      children: "✔️"
    }, r],
    customStyleHookMapping: ke
  });
  return Le({
    open: p,
    ref: s,
    onComplete() {
      p || l(!1);
    }
  }), i;
}));
process.env.NODE_ENV !== "production" && (ye.displayName = "Inner");
const ge = /* @__PURE__ */ g.memo(/* @__PURE__ */ g.forwardRef(function(t, n) {
  const {
    indexRef: u,
    textRef: o,
    selectedByFocus: r
  } = Q(), {
    selectedItemTextRef: p
  } = he(), {
    className: s,
    render: v,
    ...c
  } = t, l = g.useCallback((i) => {
    i && queueMicrotask(() => {
      const d = p.current === null || !p.current.isConnected;
      (r || d && u.current === 0) && (p.current = i);
    });
  }, [p, u, r]);
  return X("div", t, {
    ref: [l, n, o],
    props: c
  });
}));
process.env.NODE_ENV !== "production" && (ge.displayName = "SelectItemText");
const ct = be({
  slots: {
    selectItem: [
      "flex",
      "min-w-[var(--anchor-width)]",
      "cursor-pointer",
      // "grid-cols-[0.75rem_1fr]",
      "items-center",
      "gap-2",
      "py-3",
      "pr-4",
      "pl-2.5",
      "text-sm",
      "leading-4",
      "outline-none",
      "select-none",
      // Group data-side=none variants
      "group-data-[side=none]:min-w-[calc(var(--anchor-width)+1rem)]",
      "group-data-[side=none]:pr-12",
      "group-data-[side=none]:text-base",
      "group-data-[side=none]:leading-4",
      // Highlighted state
      "data-[highlighted]:relative",
      "data-[highlighted]:z-0",
      "data-[highlighted]:text-black",
      "data-[highlighted]:before:absolute",
      "data-[highlighted]:before:inset-x-1",
      "data-[highlighted]:before:inset-y-0",
      "data-[highlighted]:before:z-[-1]",
      "data-[highlighted]:before:rounded-lg",
      "data-[highlighted]:before:bg-primary-main/10"
    ],
    selectItemIndicator: ["flex-grow-0"],
    selectItemIndicatorIcon: ["size-4"],
    selectItemText: ["flex-grow pl-2"]
  }
}), {
  selectItem: lt,
  selectItemIndicatorIcon: at,
  selectItemIndicator: dt,
  selectItemText: ft
} = ct(), pt = (e) => {
  const { value: t, children: n, label: u, className: o, ...r } = e;
  return /* @__PURE__ */ M.jsxs(
    ve,
    {
      className: lt({
        className: typeof o == "string" ? o : ""
      }),
      value: t,
      label: u,
      ...r,
      children: [
        /* @__PURE__ */ M.jsx(ge, { className: ft(), children: u && !n ? u : n }),
        /* @__PURE__ */ M.jsx(Se, { className: dt(), children: /* @__PURE__ */ M.jsx(Te, { className: at() }) })
      ]
    }
  );
};
pt.displayName = "Option";
export {
  pt as O,
  pe as S,
  me as a,
  he as b,
  xt as c,
  it as i,
  F as s,
  U as u
};
